import { render, staticRenderFns } from "./ProveedorUpdate.vue?vue&type=template&id=12b4a288&scoped=true&"
import script from "./ProveedorUpdate.vue?vue&type=script&lang=js&"
export * from "./ProveedorUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4a288",
  null
  
)

export default component.exports